export enum ActionButtonTooltipEnum {
    Edit = "Edit",
    Delete = "Delete",
    Download = "Download",
    Print = "Print",
    Deactivate = "Deactivate",
    Notes = "Notes",
    NoeStatus = "Change status to submitted"
}
